import { Component, OnInit, OnDestroy } from '@angular/core';
import { CustomOktaAuthService } from '../../auth/oktaauth.service';
import { filter, Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UserData } from '../../auth/auth.model';
import { PowerBIService } from '../../reports/powerbiservice.service';
import { ReportConfigurationDTO } from '../../reports/report-config.dto';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { FilterService } from '../loadreportwithfilters/filterservice.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy {

  isAuthenticated: boolean;
  loggedInUserName: string;
  appURL: string;
  reportLinks: ReportConfigurationDTO[] = [];
  SurveyMenuTitle: string = 'Surveys';
  anyExportEnabled = false;

  private authSvcSubscription: Subscription;
  private pbiSvcSubscription: Subscription;
  private exportCheckRequestedSubscription: Subscription;

  constructor(private authSvc: CustomOktaAuthService, private pbiSvc: PowerBIService, private oktaService: CustomOktaAuthService, private activatedRoute: ActivatedRoute, private router:Router, private filterService: FilterService) {
    this.appURL = environment.appURL;
  }

  ngOnInit() {

    this.exportCheckRequestedSubscription = this.filterService.exportCheckRequested$
      .subscribe((orgIds) => this.checkExportEnabledForOrg(orgIds, true));

    this.authSvcSubscription = this.authSvc.userAuthenticatedListener()
      .subscribe((userClaims: UserData) => {
        this.oktaService.refreshToken('header component on init');
        if (userClaims) {
          this.isAuthenticated = true;
          this.loggedInUserName = userClaims.username;
          this.pbiSvcSubscription = this.pbiSvc.getAllReports().subscribe((response) => {
            //console.log(response);
            this.reportLinks = [...response];
            sessionStorage.setItem('reportLinks', JSON.stringify(this.reportLinks));
            this.reportLinks = this.reportLinks.filter(x => x.isActive);

            //console.log('HeaderComponent: this.router.url: ' + this.router.url);
            this.updateSurveyMenuTitle(this.router.url);
            this.router.events
              .pipe(filter(event => event instanceof NavigationEnd))
              .subscribe((event: NavigationEnd) => {
                //console.log('HeaderComponent: event.url: ' + event.url);
                this.updateSurveyMenuTitle(event.url);
              });
          });
        } else {
          this.isAuthenticated = false;
          this.loggedInUserName = '';
        }


      });
  }
  updateSurveyMenuTitle(url: string) {
    if(url && url.indexOf('loadreport') == -1)
    {
      this.SurveyMenuTitle = 'Surveys';
      return;
    }
    let urlSegments = url.split('/');
    //find report name from reportLinks array based on last segment of the url
    let report = this.reportLinks.find(x => x.tag == urlSegments[urlSegments.length - 1]);
    if (report)
      this.SurveyMenuTitle = report.displayName;
  }
  ngOnDestroy() {
    if(this.authSvcSubscription)
    this.authSvcSubscription.unsubscribe();
    if(this.pbiSvcSubscription)
    this.pbiSvcSubscription.unsubscribe();
    if(this.exportCheckRequestedSubscription)
    this.exportCheckRequestedSubscription.unsubscribe();
  }

  // There's no "default" org to guess at login time - this only runs once a
  // report page resolves real orgIds (see FilterService.requestExportCheck),
  // so the header always agrees with that report's own Export button.
  private checkExportEnabledForOrg(orgIds: string, retryOnFailure: boolean) {
    if (!orgIds || !this.reportLinks.some(r => r.exportEnabled)) {
      this.anyExportEnabled = false;
      return;
    }
    this.filterService.ExportEnabledOrDisabled('Export', orgIds).subscribe({
      next: (enabled) => this.anyExportEnabled = enabled === true,
      error: () => {
        // Can 401 on a cold IAM lookup; retry once against the same orgIds.
        if (retryOnFailure)
          setTimeout(() => this.checkExportEnabledForOrg(orgIds, false), 1500);
        else
          this.anyExportEnabled = false;
      }
    });
  }

  getReportURL(reportTagName: string) {
    return this.pbiSvc.getReportURL(reportTagName);
    // let loadReportComponentName = '/loadreport/';
    // const LOADREPORT_V1 = '/loadreportv1/', LOADREPORT = '/loadreport/', LOADREPORT_V2 = '/loadreportv2/';

    // if (reportTagName.toLocaleLowerCase().indexOf('v1') == -1 && reportTagName.toLocaleLowerCase().indexOf('2023') == -1)
    //   loadReportComponentName = LOADREPORT;
    // else if (reportTagName.toLocaleLowerCase().indexOf('2023') != -1)
    //   loadReportComponentName = LOADREPORT_V2;
    // else
    //   loadReportComponentName = LOADREPORT_V1;

    // return loadReportComponentName + reportTagName;
  }
}

export const HeaderBasicData = {
  name: 'HeaderBasic'
};
